"use client";

import { Avatar, AvatarFallback, AvatarImage } from "../ui/avatar";
import { WPAPIPostGraphQL, WPRecentPost } from "@/types";

import { Calendar } from "lucide-react";
import DateRender from "../DateRender";
import Link from "next/link";
import React from "react";
import { cn } from "@/lib/utils";

interface BlogAuthorProps {
  post: WPRecentPost | WPAPIPostGraphQL;
  showDate?: boolean;
  recentPostMode?: boolean;
}

export default function BlogAuthor({
  post,
  showDate,
  recentPostMode,
}: BlogAuthorProps) {
  const postAuthor = post.node.author?.node;

  if (!postAuthor?.name) return null;

  return (
    <Link
      href={`/blog/author/${encodeURI(postAuthor.name.toLocaleLowerCase())}`}
      className="w-full flex"
    >
      <div className="flex w-full gap-2 items-center justify-start text-sm">
        <Avatar className="h-8 w-8">
          <AvatarImage src={postAuthor.avatar.url} alt={postAuthor.name} />
          <AvatarFallback>
            <span className="mx-auto">{postAuthor.name?.slice(0, 1)}</span>
          </AvatarFallback>
        </Avatar>
        <span className={cn(recentPostMode && "text-white", "tracking-wide")}>
          by {postAuthor.name}
        </span>
        {showDate && (
          <>
            {" "}
            <Calendar className="h-4 ml-auto" />
            <span>
              <DateRender post={post} />
            </span>
          </>
        )}
      </div>
    </Link>
  );
}
